

exports.__esModule = true;
exports.landingPageResolver = void 0;
var _squid = require("squid");
var _index = require("xo-models/src/checkout/index");
var _logger = require("xo-beaver/dist/logger");
var _angular = require("angular");
var _uiRouter = require("uiRouter");
var landingFlow = function landingFlow(models) {
  var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
  var merchantId = models.checkoutPayeeModel.getId();
  var paymentMethodViaUrl = _squid.$util.param('paymentMethod');
  var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
  var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
  var isUnbranded = paymentMethod !== undefined;
  function getProcessedRoute(appRoute) {
    var isForcedSignup;
    switch (appRoute) {
      case 'checkout.guest':
        isForcedSignup = 0;
        break;
      case 'checkout.signup':
      case 'checkout.multistepsignup':
        isForcedSignup = 1;
        break;
      default:
        isForcedSignup = -1;
        break;
    }
    _logger.$logger.info('checkout_fpti', {
      from: 'LANDING_PAGE_PARAM',
      forced_signup_offered: isForcedSignup,
      landing_page: 'Billing',
      locale: _squid.$locale.lang + "_" + _squid.$locale.country
    });
    return appRoute;
  }
  function getBlockedSignupErrorMessage(country) {
    if (country === 'IN') {
      return 'PAYEE_ACCOUNT_LOCKED_OR_CLOSED';
    }
    return "SIGNUP_BLOCKED_IN_COUNTRY_" + country;
  }
  function callEPM() {
    return _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
      params: {
        localeCountry: _squid.$locale.country,
        fundingSource: window.xprops && window.xprops.fundingSource,
        merchantId: merchantId,
        merchantCountry: merchantCountry
      }
    }).then(function (flowEligibility) {
      var mode = flowEligibility.guest ? 'guest' : 'signup';
      _logger.$logger.info(mode + "_flow_offered_by_epm_at_route");
      // TH force signup is blocked due to compliance requirements.
      if (mode === 'signup' && (0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      var appRoute = mode === 'signup' ? 'checkout.signup' : 'checkout.guest';
      return getProcessedRoute(appRoute);
    });
  }
  if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
    var passedInExp = _squid.$util.param('showExp');
    if ('guest'.includes(passedInExp)) {
      return getProcessedRoute('checkout.guest');
    }
    if ('signup'.includes(passedInExp)) {
      // TH force signup is blocked due to compliance requirements.
      if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info("DEV_STAGING_" + _squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      return getProcessedRoute('checkout.signup');
    }
  }
  if (isUnbranded) {
    _logger.$logger.info("unbranded_flow_paymentMethod_" + paymentMethod);
    _logger.$logger.info('checkout_fpti', {
      from: 'BILLING',
      to: "prepare_billing_page_for_unbranded_paymentMethod_" + paymentMethod,
      locale: _squid.$locale.lang + "_" + _squid.$locale.country
    });
    var isUnbrandedAllowed = (0, _squid.$feature)('unbranded', true, merchantCountry);
    var isPuiAllowed = (0, _squid.$feature)('invoicePayment', true, merchantCountry);
    if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
      return getProcessedRoute('checkout.pay-upon-invoice');
    }
    return getProcessedRoute('checkout.guest');
  } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && _squid.$util.param('exp') === 'signup') {
    _logger.$logger.info('ppplus_flow_signup');
    if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
      _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED_FOR_PPPLUS");
      return _uiRouter.$state.go('checkout.genericError', {
        code: getBlockedSignupErrorMessage(_squid.$locale.country)
      });
    }
    return getProcessedRoute('checkout.signup');
  } else if ((0, _squid.$feature)('multiStepSignup', false, _squid.$locale.country)) {
    return getProcessedRoute('checkout.multistepsignup');
  } else if (models.checkoutInputData.isEbayTxn()) {
    // force signup for eBay users
    _logger.$logger.info('ebay_flow_signup');
    if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
      _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED_FOR_EBAY");
      return _uiRouter.$state.go('checkout.genericError', {
        code: getBlockedSignupErrorMessage(_squid.$locale.country)
      });
    }
    return getProcessedRoute('checkout.signup');
  } else {
    // if you here means, now we need to determine the route based on symphony EPM call.
    return callEPM();
  }
};
var landingPageResolver = exports.landingPageResolver = {
  landingFlow: landingFlow
};
_squid.$util;
_squid.$feature;
_squid.$config;
_squid.$locale;
_index.$FlowEligibilityModel;
_logger.$logger;
_angular.$rootScope;
_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/helper.js
// module id = ./pages/xo-landing/helper.js
// module chunks = 0